
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/debtreliefoasis/terms-and-conditions",
      function () {
        return require("private-next-pages/debtreliefoasis/terms-and-conditions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/debtreliefoasis/terms-and-conditions"])
      });
    }
  